import { render } from "./TimetableSelectWeek.vue?vue&type=template&id=1b7e8ba6&scoped=true"
import script from "./TimetableSelectWeek.vue?vue&type=script&lang=js"
export * from "./TimetableSelectWeek.vue?vue&type=script&lang=js"

import "./TimetableSelectWeek.vue?vue&type=style&index=0&id=1b7e8ba6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7e8ba6"]])

export default __exports__